import { render } from "./Financeiro.vue?vue&type=template&id=3bfeaf06"
import script from "./Financeiro.vue?vue&type=script&lang=js"
export * from "./Financeiro.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__